import { Pipe, PipeTransform } from '@angular/core';
import { BoletoPipe } from 'app/resources/pipes/boleto.pipe';
import { TributoPipe } from 'app/resources/pipes/tributo.pipe';

@Pipe({
  name: 'pagamento'
})
export class PagamentoPipe implements PipeTransform {
  private boleto = new BoletoPipe();
  private tributo = new TributoPipe();
  transform(linhaDigitavel: any, tipo?: any): any {
    if (linhaDigitavel) {
      if (tipo) {
        if (tipo === 'boleto') {
          return this.boleto.transform(linhaDigitavel, 0);
        } else if (tipo === 'conta_consumo') {
          return this.tributo.transform(linhaDigitavel, 0);
        }
      }
    }
    return linhaDigitavel;

  }

}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/pagamento.pipe.ts